import { AutogenLayoutPreassignmentPrompt } from "./autogen/AutogenLayoutPreassignmentPrompt";

export class PreassignmentPrompt extends AutogenLayoutPreassignmentPrompt {
}
